<!-- 正在发车的急救车表格 处理-->
<template>
  <div class="working">
    <div class="working-header">
      <span>正在处理：</span>
      <el-button class="add-new-mission" @click="addNewMission">新增</el-button>
    </div>
    <div class="working-table">
      <el-table
        :data="currentPatientList"
        :height="180"
        :border="false"
      >
        <el-table-column
          align="center"
          prop="number"
          label="事件编号"
          width="110"
        />
        <el-table-column
          align="center"
          prop="formatTime"
          label="受理时间"
          width="160"
        />
        <el-table-column
          align="center"
          prop="急救车编号"
          label="对象"
          width="170"
        >
          <template #default="{row}">
            <!--            急救车-->
            <span v-if="row.ambulance_type === '急救车'">{{ carPlate[row.ambulanceId] + "-" + row.carName }}</span>
            <!--            无人机 无人车-->
            <span v-else>{{ row.carName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="turout_time"
          label="发车时间"
          width="160"
        />
        <el-table-column
          align="center"
          prop="stage"
          label="阶段"
          width="100"
        />
        <el-table-column
          align="center"
          prop="patientAddr"
          label="地点"
          width="180"
        />
        <el-table-column
          align="center"
          prop="mainComplaint"
          class-name="main-complaint"
          label="主诉"
          width="240"
        />
        <el-table-column align="center" prop="operate" label="操作">
          <template #default="{row}">
            <el-button
              type="text"
              size="medium"
              @click="handleEdit(row.id, row.ambulance_type)"
            >编辑
            </el-button>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="operate" label="">
          <template #default="scope">
            <el-button
              type="text"
              size="medium"
              @click="
                handleOver(
                  scope.$index,
                  scope.row,
                )
              "
            >结束
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DealTable",
  props: {
    currentPatientList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["clickOver", "addNewMission"],
  computed: {
    ...mapState({
      carPlate: "carPlate"
    })
  },
  methods: {
    /**
     * 跳转到编辑页面,进行重新编辑
     * @param {number} id - 编辑的id
     * @param {string} ambulanceType - 急救车/ 无人机/ 无人车
     * */
    handleEdit(id, ambulanceType) {
      if (ambulanceType === "急救车") {
        this.$router.push({ path: `/addPatient/${id}` });
      } else {
        this.$router.push({ path: `/addPatientSmart/${id}` });
      }
    },
    /**
     * 结束急救车事件
     * @param {number} index - 结束的元素序列
     * @param {Object} data - 结束的内容
     * */
    handleOver(index, data) {
      const { id, number } = data; // 事件ID, 病例ID
      this.$emit("clickOver", { id, number, index });
    },
    addNewMission() {
      this.$emit("addNewMission");
    },
  },
};
</script>

<style scoped lang="scss">
.working {
  height: 318px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 0 30px
}

.working-header {
  padding: 24px 0;
  display: flex;
  justify-content: space-between;

  .add-new-mission {
    height: 32px;
    background: #2AA5E3;
    border-radius: 8px;

    font-size: 16px;
    color: #FBFBFB;
  }

  span {
    font-size: 20px;
    font-weight: bold;
    color: #00476B;
  }

  .add-button {
    width: 32px;
    height: 32px;
    background: #e4e1e1;
    border-radius: 50%;
    vertical-align: middle;
    cursor: pointer;
  }
}

::v-deep {
  .main-complaint div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
  }
}
</style>
